import { Cpu, Flag, Search } from "lucide-react";

export default function ServicesSection() {
  const services = [
    { id: "chiptuning", title: "Chiptuning & ECU Remapping", description: "Professional ECU tuning to unlock your engine's full potential. Stage 1, Stage 2, and custom tunes tailored to your specific setup and goals.", icon: Cpu },
    { id: "racebuilds", title: "Special Requests", description: "From street-legal track weapons to full race cars. Roll cages, performance upgrades, weight reduction, and complete race preparations.", icon: Flag },
    { id: "diagnostics", title: "Advanced Diagnostics", description: "State-of-the-art diagnostic equipment for accurate fault finding. VCDS, OBDeleven, and manufacturer-specific tools for comprehensive analysis.", icon: Search },
  ];

  return (
    <section id="services" data-testid="services-section" className="py-24 px-4 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="section-title text-4xl sm:text-5xl text-white mb-4">Our Services</h2>
          <p className="text-[#8A8A8A] mt-8 max-w-2xl mx-auto">Expert automotive services delivered with precision and passion</p>
        </div>
        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {services.map((service, index) => (
            <div key={service.id} data-testid={`service-card-${service.id}`} className="service-card rounded-lg p-8 tracing-beam" style={{ animationDelay: `${index * 0.1}s` }}>
              <div className="icon-wrapper w-14 h-14 rounded-lg flex items-center justify-center mb-6">
                <service.icon className="text-white" size={28} />
              </div>
              <h3 className="text-2xl text-white mb-4">{service.title}</h3>
              <p className="text-[#8A8A8A] leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
